import isCleartextEmail from './isCleartextEmail';

const firstCleartextEmail = (...candidates: (string | null | undefined)[]): string | undefined => (
    candidates.find(isCleartextEmail)
);

export default firstCleartextEmail;
